import { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

type Mode = "archive" | "restore";

type Props = {
  open: boolean;
  mode: Mode;
  /** The book being archived, lowercase: "counterparty", "broker", "country". */
  entityLabel: string;
  /** Name of the record, shown in bold in the confirmation text. */
  entityName: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ArchiveConfirmDialog: FC<Props> = ({
  open,
  mode,
  entityLabel,
  entityName,
  onCancel,
  onConfirm
}) => {
  const isArchive = mode === "archive";

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        {isArchive ? `Archive ${entityLabel}?` : `Restore ${entityLabel}?`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isArchive ? (
            <>
              <strong>{entityName}</strong> will be hidden from the active list.
              Assigned task owners will be notified that work should stop. You
              can restore it from the Archived tab at any time.
            </>
          ) : (
            <>
              <strong>{entityName}</strong> will be moved back to the active
              list.
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          onClick={onConfirm}
          color={isArchive ? "error" : "primary"}
          variant="contained"
        >
          {isArchive ? "Archive" : "Restore"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
